import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./CmsList.css";
import {
  withBase,
  Button,
  LayerPopup,
  ControlBox,
  Pagination,
  PopupWrapper,
  CustomLoading,
  CustomMessage,
} from "components";
import { useSelector } from "react-redux";
import moment from "moment";
import CmsListConditionBox from "./CmsListConditionBox";
import CmsListTable from "./CmsListTable";
import CmsListPopupWrapper from "./CmsListPopupWrapper";
import CmsListPopupIndividual from "./CmsListPopupIndividual";
import CmsListPopupBatch from "./CmsListPopupBatch";
import CmsListPopupDown from "./CmsListPopupDown";

const API = {
  LIST: {
    url: "api/v1/finnc/finnc/list",
    method: "post",
  },
  CREATE: {
    url: "api/v1/finnc/finnc/create",
    method: "post",
  },
  SEND: {
    url: "api/v1/finnc/finnc/createSendNH",
    method: "post",
  },
  REMIT: {
    url: "api/v1/finnc/finnc/updateRemitGrant",
    method: "post",
  },
  DOWNFAREFEE: {
    url: "api/v1/report/fareFeeTxn/downfarefeeCms",
    method: "post",
  },
  /*
  DOWNOTPAYREQ: {
    url: "api/v1/report/fareFeeTxn/downotpayreq",
    method: "post",
  },
  DOWNFAREFEE: {
    "api/v1/report/fareFeeTxn/downfarefeeCms",
    method: "post",
  },
  UPDATE: {
    url: "api/v1/report/fareFeeTxn/updateotpay",
    method: "post",
  },
  DELETE: {
    url: "api/v1/report/fareFeeTxn/deleteotpay",
    method: "post",
  },
  DATELIST: {
    url: "api/v1/report/fareFeeTxn/listposbldate",
    method: "post",
  },
  */
  READSTATES: {
    url: "api/v1/finnc/finnc/readstates",
    method: "post",
  },
};

const CmsList = (props) => {
  const cretFlag = useSelector((state) => state.user.get("cretFlag"));
  const [param, setParam] = useState({
    dspDate: moment().add(-1, "days").format("YYYYMMDD"),
    pageNo: 1,
  });
  const [datas, setDatas] = useState([]);
  const [total, setTotal] = useState(0);
  const [layerType, setLayerType] = useState("");
  const [layerType2, setLayerType2] = useState("");
  const [viewData, setViewData] = useState(null);
  const [batchDatas, setBatchDatas] = useState([]);
  const [dateItem, setDateItem] = useState([]);
  const [batchAllDat, setBatchAllDat] = useState([]);
  const [batchAllChk, setBatchAllChk] = useState(false);
  const [states, setStates] = useState([]);

  useEffect(() => {
    list();
    readStates();
  }, [param]);

  const list = async () => {
    const { HttpRequest, searching } = props;
    searching(true);

    const { url, method } = API.LIST;
    const response = await HttpRequest.request(url, method, param);
    //const list = response.fareFeeTxnList;
    if (HttpRequest.hasError(response, true)) {
      setTotal(0);
      setDatas([]);
      setBatchDatas([]);
      searching(false);
      return;
    }
    setTotal(response.totalRowCnt);
    setDatas(response.fareFeeTxnList);
    setBatchDatas([]);

    let checkDat = [];
    response.fareFeeTxnList &&
    response.fareFeeTxnList.forEach((item) => {
        if (item.otpaySttus === "불능"
          //item.otpaySttus === "예치요청" ||
          //item.otpaySttus === "정지요청"
        ) {
          checkDat.push(item.rowNum);
        }
      });

    setBatchAllDat(checkDat);
    searching(false);
  };

  const readStates = async () => {
    const { HttpRequest, searching } = props;
    searching(true);

    const {url, method } = API.READSTATES;
    const response = await HttpRequest.request(url, method, {});

    if (HttpRequest.hasError(response, true)) {

      return;
    }

    setStates(response.stateMap);
    searching(false);

  };

  const edit = async ({ url, method }, data) => {
    const { HttpRequest } = props;
    const response = await HttpRequest.request(url, method, data);
    if (HttpRequest.hasError(response, true)) {
      return false;
    }
    setParam({
      ...param,
      pageNo: 1,
    });
    return true;
  };
  const handleClickSearch = (condition) => {
    setParam({
      ...condition,
      pageNo: 1,
    });
  };

  const handleClickDownOtpayReq = async (param) => {
    const { url } = API.DOWNOTPAYREQ;

    await props.downExcel.request(url, param);

    setLayerType("");
  };

  const handleClickDownFareFee = async () => {

    const { url } = API.DOWNFAREFEE;

    await props.downExcel.request(url, param);
  };

  const onChangeAllChk = (checked) => {
    setBatchAllChk(checked);

    if (checked) {
      setBatchDatas(batchAllDat);
    } else {
      setBatchDatas([]);
    }
  };

  const handleClickCheckBox = (index, check) => {
    check
      ? setBatchDatas([...batchDatas, index])
      : setBatchDatas(batchDatas.filter((item) => item !== index));
  };
  const handleDoubleClick = (index) => {
    setLayerType("individual");
    setViewData(datas[index]);
  };
  const handleClickDown = async () => {
    const { HttpRequest } = props;

    const { url, method } = API.DATELIST;

    const response = await HttpRequest.request(url, method, {});
    if (HttpRequest.hasError(response, true)) {
      setDateItem([]);
      return;
    }

    if (!response.CmsListList || response.CmsListList.length === 0) {
      setDateItem([]);
    } else {
      setDateItem(
        response.CmsListList.map((item) => {
          return {
            code: item.dspDate,
            name: props.formatter(item.dspDate, "date"),
          };
        })
      );
    }

    setLayerType("down");
  };
  const handleClickBatch = () => {
    if (batchDatas.length === 0) {
      props.toast.error("선택된 데이터가 없습니다.");
      return;
    }
    setLayerType("batch");
    setViewData(datas.filter((item) => batchDatas.indexOf(item.rowNum) > -1));
  };
  const handleClickClose = () => {
    setLayerType("");
    setLayerType2("message");
    setViewData(null);
  };

  const handleClickSave = async (saveType, param) => {
    setLayerType2("loading");
    let ret = false;
    let msg = "";
    switch (saveType) {
      case "remit":
        //if (window.confirm("요청 승인 하시겠습니까?")) {
        if (window.confirm("정지 하시겠습니까?")) {
          ret = await edit(API.REMIT, { fareFeeTxnList: param });
          msg = "정지 처리되었습니다.";
          if (ret) setBatchDatas([]);
        }
        break;
      case "insert":
        if (window.confirm("["+props.formatter(param.dspDate, "date")+"] 송금리스트를 생성 하시겠습니까?")) {
          ret = await edit(API.CREATE, param);
          if(ret){
            msg = "송금 리스트가 생성되었습니다.";
          }
        }
        break;
      case "send":
        if (window.confirm("농협으로 데이터를 전송 하시겠습니까?")) {
          ret = await edit(API.SEND, param);
          if(ret){
            msg = "농협전송 처리되었습니다.";
          }
        }
        break;
      default:
        console.log(saveType);
        break;
    }
    if (ret) {
      setLayerType("");
      setViewData(null);
    }
    if (msg){
      props.toast.error(msg);
    }
    setLayerType2("message");
  };
  return (
    <div className="CmsList">
      <CmsListConditionBox onClickSearch={handleClickSearch} {...props} />
      <ControlBox>
        <Button className="withdrawl_register" onClick={handleClickBatch}>
            정지
        </Button>
        <Button className="withdrawl_register" onClick={() => handleClickSave("insert", param)}>
            송금리스트생성({props.formatter(param.dspDate, "date")})
        </Button>
        <Button className="insert" onClick={() => handleClickSave("send", param)}>
           농협전송{/*!states ? "" : "(" + props.formatter(states.finaldate, "date") + ")"*/}
        </Button>
        <Button className="excel" onClick={handleClickDownFareFee}>
          엑셀 다운로드
        </Button>
      </ControlBox>
      <CmsListTable
        datas={datas}
        batchDatas={batchDatas}
        onChange={handleClickCheckBox}
        onDoubleClick={handleDoubleClick}
        batchAllChk={batchAllChk}
        onChangeAllChk={onChangeAllChk}
        formatter={props.formatter}
        cretFlag={cretFlag}
      />
      {datas && datas.length > 0 && (
        <Pagination
          page={param.pageNo}
          total={total}
          row={15}
          pageCount={10}
          fetchData={(page) => {
            setParam({
              ...param,
              pageNo: page,
            });
          }}
        />
      )}
      <PopupWrapper
        layerType={layerType2}
        title={""}
        loading={
          <CustomLoading layerType={layerType2}>
           요청 중입니다. 잠시만 기다려주십시오.
          </CustomLoading>
        }
      />
      <LayerPopup layerType={layerType} onClose={handleClickClose}>
        <CmsListPopupWrapper
          layerType={layerType}
          title={"정지요청"}
          className={"CmsListPopup"}
          batchTable={
            <CmsListPopupBatch
              layerType={layerType}
              viewData={viewData}
              onClose={handleClickClose}
              onSave={handleClickSave}
              formatter={props.formatter}
              cretFlag={cretFlag}
            />
          }
          individualTable={
            <CmsListPopupIndividual
              layerType={layerType}
              viewData={viewData}
              onClose={handleClickClose}
              onSave={handleClickSave}
              formatter={props.formatter}
              cretFlag={cretFlag}
            />
          }
          downTable={
            <CmsListPopupDown
              onClose={handleClickClose}
              onDown={handleClickDownOtpayReq}
              dateItem={dateItem}
            />
          }
        />
      </LayerPopup>
    </div>
  );
};

CmsList.propTypes = {};

export default withBase(CmsList);
